<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>风控仓位</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户UID"
                clearable
                v-model="userId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">合伙人UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
                size="mini"
              >
              </el-input>
            </div>
          </div>

          <div class="item">
            <!-- <div class="txt">合伙人手机或邮箱</div> -->
            <div class="ipt">
              <el-input
                placeholder="仓位ID"
                clearable
                v-model="positionId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">注册日期</div> -->
            <div class="ipt">
              <el-date-picker
                v-model="value1"
                type="daterange"
                align="right"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                unlink-panels
                clearable
                size="mini"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="changeTime($event)"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
            <el-button @click="exportData" size="mini">导出Excel</el-button>
          </div>
        </div>
      </div>

      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import { mapState, mapActions, mapMutations } from 'vuex'
import { QUERY_TYPE, PAGINATION } from './constants'
import api from './api'
import moment from 'moment'
export default {
  name: 'RebateRisk',
  components: {
    UserList,
  },
  data() {
    return {
      // rebateStatus: "",
      rebateStatusList: [
        { value: '', label: '全部' },
        { value: 'reword_success', label: '已发放' },
        { value: 'reword_wait', label: '未发放' },
      ],
      dialogVisible: false,
      userId: '',
      positionId: '',
      telOrEmailNext: '',
      channelId: '',
      channelUserId: '',
      inviteBy: '',

      value1: [
        moment(new Date()).format('YYYY-MM-DD'),
        moment(new Date()).format('YYYY-MM-DD'),
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      totalAmount: 0,
    }
  },
  computed: {
    ...mapState('rebateRisk', ['queryType', 'pagination']),
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapActions('rebateRisk', ['list', 'addUser']),
    ...mapMutations('rebateRisk', ['setQueryType']),
    refreshList(data = {}) {
      this.handleSearch(data)
    },

    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          'YYYY-MM-DD'
        ),
      ]
      this.handleSearch()
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
        new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          new Date().getDate(),
      ]
      this.handleSearch()
    },
    handleSearch(data) {
      this.list({
        positionId: this.positionId,
        channelUserId: this.channelUserId,
        userId: this.userId,
        // rebateStatus: this.rebateStatus,
        startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
        endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        ...PAGINATION,
        ...data,
      })
    },
    exportData() {
      const data = {
        positionId: this.positionId,
        channelUserId: this.channelUserId,
        userId: this.userId,
        startTime: this.value1 && this.value1[0] ? this.value1[0] : '',
        endTime: this.value1 && this.value1[1] ? this.value1[1] : '',
        page: this.pagination.page,
        size: this.pagination.size,
      }
      api.getExcelData(data).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址

        link.download = '风控仓位'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },
  },
  mounted() {
    this.handleSearch()
  },
}
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
